module.exports = __webpack_public_path__ + "img/ccic.49c29ffc.png";